import PropTypes from "prop-types";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

// form
// @mui
import { Box, Container } from "@mui/material";

import { Helmet } from "react-helmet-async";

import CustomBreadcrumbs from "../../components/custom-breadcrumbs";
import { useSettingsContext } from "../../components/settings";

// TODO: redux
import { useDispatch, useSelector } from "react-redux";
import LoadingScreen from "../../components/loading-screen";
import { getSingleFanChoice } from "../../redux/slices/fanchoice";
import { PATH_DASHBOARD } from "../../routes/paths";
import FanChoiceForm from "../../sections/fanchoice/FanChoiceForm";

// ----------------------------------------------------------------------

FanChoiceDetail.propTypes = {
  isEdit: PropTypes.bool,
  view: PropTypes.bool,
};

export default function FanChoiceDetail({ isEdit = false, view = false }) {
  // TODO: declarations
  const { themeStretch } = useSettingsContext();
  const dispatch = useDispatch();
  const route = useParams();

  const { id } = route;

  // TODO: fetch

  useEffect(() => {
    dispatch(getSingleFanChoice({ id }));
  }, [dispatch, id]);

  // TODO: fetch data from store

  const isLoading = useSelector((state) => state.fanChoice.fetchLoading);
  const singleFanChoice = useSelector(
    (state) => state.fanChoice.singleFanChoice
  );

  return (
    <Box>
      <Helmet>
        <title> NKL: Fan Choice Detail</title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : "xl"}>
        <CustomBreadcrumbs
          heading="Fan Choice"
          links={[
            {
              name: "Dashboard",
              href: PATH_DASHBOARD.root,
            },
            {
              name: "Fan Choice",
              href: PATH_DASHBOARD.fanChoice.list,
            },
            {
              name: `Fan Choice`,
            },
          ]}
        />

        {isLoading ? (
          <LoadingScreen />
        ) : (
          <FanChoiceForm row={singleFanChoice} isEdit={isEdit} view={view} />
        )}
      </Container>
    </Box>
  );
}
